/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as QueueDefs from './defs.defs.js'

const $nsid = 'tools.ozone.queue.createQueue'

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $input = /*#__PURE__*/ l.jsonPayload({
  name: /*#__PURE__*/ l.string(),
  subjectTypes: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.string<{ knownValues: ['account', 'record', 'message'] }>(),
    { minLength: 1 },
  ),
  collection: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string({ format: 'nsid' }),
  ),
  reportTypes: /*#__PURE__*/ l.array(/*#__PURE__*/ l.string(), {
    minLength: 1,
    maxLength: 25,
  }),
  description: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
})

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>

export const $output = /*#__PURE__*/ l.jsonPayload({
  queue: /*#__PURE__*/ l.ref<QueueDefs.QueueView>(
    (() => QueueDefs.queueView) as any,
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Create a new moderation queue. Will fail if the queue configuration conflicts with an existing queue. */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output, [
  'ConflictingQueue',
])

export { main }

export const $lxm = $nsid
